/*
 * https://www.drupal.org/docs/8/api/javascript-api/javascript-api-overview
 */

(function ($) {
  'use strict';

  // Open all external links to a new tab/window
  $('a')
    .filter(function () {
      return this.hostname && this.hostname !== location.hostname;
    })
    .addClass('is-external')
    .attr({
      rel: 'noopener',
      target: '_blank',
    });
})(jQuery, Drupal);
